import { Avatar, theme } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import logo from '../resources/img/cleverlohn_avatar.svg'
import { EditorRole } from '../lib/shared/models/EditorRole'
import { appsByUids } from '../lib/shared/models/ConfigApp'

function hashCode(str: string) {
  if (!str) return 0
  let hash = 0
  for (let i = 0, len = str.length; i < len; i++) {
    let chr = str.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0 // Convert to 32bit integer
  }
  return hash
}

/**
 * @component
 * @param uid - string The user's uid
 * @param name - string
 * @param size - 'small' | 'default' | 'large'
 * @param style
 * @param role - EditorRole
 */
export function UserAvatar({
  uid,
  name,
  size = 'default',
  style = {},
  role,
}: {
  uid: string
  name: string
  size: 'small' | 'default' | 'large'
  style?: any
  role?: EditorRole
}) {
  const { token } = theme.useToken()

  if (role === 'system') {
    return (
      <Avatar
        size={size}
        // theme-ok: fixed dark disc behind the brand mark
        style={{ backgroundColor: '#282828' }}
        src={logo}
        // @ts-expect-error title not a valid prop
        title="cleverlohn"
      />
    )
  } else if (role === 'app') {
    const app = appsByUids[uid]

    if (app) {
      return (
        <Avatar
          size={size}
          src={`/apps/${app.icon}`}
          // @ts-expect-error title not a valid prop
          title={app.name}
        />
      )
    }
  }

  // antd palette steps: same hues as before in light, remapped in dark
  const avatarColors = [
    token.red6,
    token.volcano6,
    token.orange6,
    token.gold6,
    token.green6,
    token.cyan6,
    token.blue6,
    token.purple6,
    token.purple5,
    token.purple4,
    token.magenta6,
  ]
  const avatarColor = name
    ? avatarColors[Math.abs(hashCode(uid ?? name) % avatarColors.length)]
    : null

  return (
    <Avatar
      size={size}
      style={{
        backgroundColor: avatarColor,
        color: token.colorTextLightSolid,
        ...style,
      }}
      icon={name ? null : <UserOutlined />}
      // @ts-expect-error title not a valid prop
      title={name}
    >
      {name?.substring(0, 1)?.toUpperCase()}
    </Avatar>
  )
}
